export default __webpack_public_path__ + "static/mort.de.stalline-c628df2c79e08cb21acc2f668b751ecc.jpg";